import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class LeasingPlansApi extends Api {
  constructor() {
    super('leasings/plans/');
  }

  getFile(url) {
    return axios({
      url,
      method: 'get',
      data: {},
      params: {},
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        'auth-token': AuthService.getToken(),
      },
    });
  };

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/leasings/plans.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }
}

export default LeasingPlansApi;
